import { FC } from 'react';
import { Dialog, Portal, CloseButton } from '@chakra-ui/react';
import ExerciseSearchPanel from './ExerciseSearchPanel';
import Typhography from '../../../shared/Typhography/Typhography';
import { IProgrammingExercise } from '../../../models/programming';
import style from './ExercisePickerModal.module.scss';

interface ExercisePickerTarget {
  dayLocalId: string;
  blockLocalId: string;
  exLocalId: string;
}

interface ExercisePickerModalProps {
  target: ExercisePickerTarget | null;
  onSelect: (target: ExercisePickerTarget, exercise: IProgrammingExercise) => void;
  onClose: () => void;
}

const ExercisePickerModal: FC<ExercisePickerModalProps> = ({ target, onSelect, onClose }) => {
  if (!target) return null;

  return (
    <Dialog.Root
      open={true}
      onOpenChange={(e) => { if (!e.open) onClose(); }}
      size="lg"
      placement="center"
      lazyMount
      unmountOnExit
    >
      <Portal>
        <Dialog.Backdrop className={style.backdrop} />
        <Dialog.Positioner className={style.positioner}>
          <Dialog.Content className={style.content}>
            <div className={style.header}>
              <Typhography size="bold-20">Seleziona esercizio</Typhography>
              <Dialog.CloseTrigger asChild>
                <CloseButton size="sm" className={style.closeBtn} />
              </Dialog.CloseTrigger>
            </div>
            <div className={style.scrollContainer}>
              <ExerciseSearchPanel
                onSelect={(exercise) => {
                  onSelect(target, exercise);
                  onClose();
                }}
              />
            </div>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ExercisePickerModal;
